import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';
import ResourceTile from '../../shared/resource-tile';
import { content } from './content';

const Resources = () => (
  <div className='pad-left-sm pad-right-sm'>
    <SRow>
      <SCol span='12' center='' className='pad-top-lg'>
        <h1 data-ref='buy.signup.thankyou.resources.header' className='text-center'>
          {t('client.headings.while-you-wait')}
        </h1>
      </SCol>
    </SRow>
    <SRow>
      {content.map(({ title, textContent, buttonText = '', link = '' }) => (
        <ResourceTile title={title} textContent={textContent} buttonText={buttonText} link={link} key={title} />
      ))}
    </SRow>
  </div>
);

export default Resources;
